export function isIOS() {
  return (
    /iPad|iPhone|iPod|ios|safari|iphone/.test(navigator.userAgent) &&
    !(window as any).MSStream
  );
}
